export enum SourceMediaTypes {
  INTERP_VIDEO = 'INTERP_VIDEO',
  INTERP_AUDIO = 'INTERP_AUDIO',
  HEARING_AUDIO = 'HEARING_AUDIO',
  DEAF_VIDEO = 'DEAF_VIDEO',
  DEAF_AUDIO = 'DEAF_AUDIO',
}
